export default "__VITE_ASSET__d9c62ded__"